import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import NavigationLink from "../../components/NavigationLink/NavigationLink";
import { EditActions, editActions } from "../../actions/editActions";
import { ColumnActions, columnActions } from "../../actions/columnActions";
import { pdApiActions, PdApiActions } from "../../actions/pdApiActions";
import {
  editedObjectIdSelector,
  isEditActiveSelector,
  editedObjectIdentifierSelector,
  domainSelector
} from "../../reducers/editReducer";
import { DomainsTable } from "./Domains/DomainsTable";
import { ParameterCategoriesTable } from "../common/ParameterCategories/ParameterCategoriesTable";
import {
  createEmptyParameterCategory,
  setParameterCategoryEnumExtraProperties,
  createEmptyDomain,
  setDomainEnumExtraProperties,
  createEmptyEnum,
  createEmptyFaultComponent,
  setFaultComponentExtraProperties
} from "../../utils/pdApiUtils";
import { ActionMenu } from "../common/ActionMenu/ActionMenu";
import ContentLayout from "../../components/ContentLayout/ContentLayout";
import EnumTable from "../common/EnumTable/EnumTable";
import { FaultComponentsTableCommon } from "../Lift/FaultComponents/FaultComponentsTableCommon";
import { mainActions } from "../../actions/mainActions";
import { Filter } from "../../components/Table/Migration/LegacyTypes";
import _ from "lodash";
type StateProps = {
  pdApi: State.PdApi | undefined;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  editedObject: Api.AnyItem | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  domainName: string;
  filterOptions: State.FilterOptions;
};

type DispatchProps = {
  columnActions: typeof columnActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
  pdApiActions: typeof pdApiActions;
};

type OwnProps = {
  subMenuRoute: State.EnumerationSubmenu;
};

// Props of the component
export type EnumerationsProps = StateProps & DispatchProps & OwnProps;

type EnumerationsState = {
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.EnumerationSubmenu]: Filter[];
  };
};

export class Enumerations extends React.Component<EnumerationsProps, EnumerationsState> {
  state = {
    isModalOpen: false,
    tableColumnFilters: {
      Domains: [],
      "Parameter Categories": [],
      Electrifications: [],
      "Fault Components": []
    }
  };
  private groupName = "enumerations";

  componentDidMount(): void {
    if (this.props.pdApi.escalatorParameters.length === 0) {
      this.props.pdApiActions.fetchEscalatorParameters();
    }
    if (this.props.pdApi.apmParameters === undefined) {
      this.props.pdApiActions.fetchAPMParamters();
    }
    if (this.props.pdApi.apmFaults === undefined) {
      this.props.pdApiActions.fetchAPMFaults();
    }
    if (this.props.pdApi.escalatorFaults.length === 0) {
      this.props.pdApiActions.fetchEscalatorFaults();
    }
    if (this.props.pdApi.signalizationFaults === undefined) {
      this.props.pdApiActions.fetchSignalizationFaults();
    }
    if (this.props.pdApi.DoorVersions === undefined) {
      this.props.pdApiActions.fetchDoorBindings("Door Versions");
    }
    if (this.props.pdApi.driveFaults === undefined) {
      this.props.pdApiActions.fetchDriveFaults();
    }
    if (this.props.pdApi.liftFaults === undefined) {
      this.props.pdApiActions.fetchLiftFaults();
    }
    if (this.props.pdApi.groupFaults === undefined) {
      this.props.pdApiActions.fetchGroupFaults();
    }
    if(this.props.pdApi.driveParameters === undefined) {
      this.props.pdApiActions.fetchDriveParameters();
    }
    if(this.props.pdApi.networkFaults === undefined) {
      this.props.pdApiActions.fetchNetworkFaults();
    }
    if(this.props.pdApi.monitoringFaults === undefined) {
      this.props.pdApiActions.fetchMonitoringFaults();
    }
    const escalatorVersions = this.props.pdApi.EscalatorVersions;
    if (!escalatorVersions || _.isEmpty(escalatorVersions)) {
      this.props.pdApiActions.fetchEscalatorVersions("Escalator Versions");
    }
  }
  /**
   * To add new sub page to this parent, add it here
   */
  subPages: Internal.SubPages = {
    Domains: {
      itemName: "domain",
      PdApiField: "domains",
      dataView: DomainsTable,
      createEmpty: createEmptyDomain,
      setExtraProperties: setDomainEnumExtraProperties
    },

    "Parameter Categories": {
      itemName: "parameter category",
      PdApiField: "parameterCategories",
      dataView: ParameterCategoriesTable,
      createEmpty: createEmptyParameterCategory,
      setExtraProperties: setParameterCategoryEnumExtraProperties
    },
    Electrifications: {
      itemName: "electrification",
      PdApiField: "electrifications",
      dataView: EnumTable,
      createEmpty: createEmptyEnum,
      setExtraProperties: null
    },
    "Fault Components": {
      itemName: "fault component",
      PdApiField: "faultComponents",
      dataView: FaultComponentsTableCommon,
      createEmpty: createEmptyFaultComponent,
      setExtraProperties: setFaultComponentExtraProperties
    }
  };

  render(): JSX.Element {
    const { subMenuRoute } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const submenuLinks = Object.keys(this.subPages).map((subPageName: any) =>
      this.buildLink(subPageName)
    );
    const actionMenu = this.getActionMenu(subMenuRoute);
    const dataView = this.getDataView(subMenuRoute);
    const modal = this.buildModal();

    return (
      <>
        <ContentLayout submenu={submenuLinks} actionMenu={actionMenu} dataView={dataView} />
        {modal}
      </>
    );
  }

  private setColumnFilters = (
    subMenuRoute: State.AnySubMenu | State.AnyChildItem,
    newFilters: Filter[]
  ): void => {
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  private getDataView = (subMenuRoute: State.EnumerationSubmenu): JSX.Element => {
    if (subMenuRoute === "Electrifications") {
      return (
        <EnumTable
          subMenuRoute={subMenuRoute}
          toggleModal={this.toggleModal}
          dataFieldName={this.subPages[subMenuRoute].PdApiField}
          setColumnFilters={this.setColumnFilters}
        />
      );
    } else {
      const passProps = {
        ...this.props,
        setColumnFilters: this.setColumnFilters,
        toggleModal: this.toggleModal,
        parentMenu: "Enumerations"
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    }
  };

  private getActionMenu = (subMenuRoute: State.EnumerationSubmenu): JSX.Element | null => (
    <ActionMenu
      {...this.props}
      itemName={this.subPages[subMenuRoute].itemName}
      selectedColumnsName={subMenuRoute}
      dataFieldName={this.subPages[subMenuRoute].PdApiField}
      setExtraProperties={this.subPages[subMenuRoute].setExtraProperties}
      createEmpty={this.subPages[subMenuRoute].createEmpty}
      columnFilters={this.state.tableColumnFilters[subMenuRoute]}
    />
  );

  private buildLink = (subPageName: State.EnumerationSubmenu): JSX.Element => {
    // To dynamically build urls we use the itenName and make it plural, so -s || -y => -ies
    let parsedLink = this.subPages[subPageName].itemName.replace(" ", "-");
    parsedLink = parsedLink.slice(-1) === "y" ? parsedLink.slice(0, -1) + "ies" : parsedLink + "s";
    return (
      <NavigationLink
        key={subPageName}
        handleOnClick={this.props.editActions.cancelEditing}
        name={subPageName}
        to={"/" + this.groupName.toLowerCase() + "/" + parsedLink + "/"}
      />
    );
  };

  private buildModal = () => {
    const domainName = this.props.domainName ? " Domain: " + this.props.domainName : "";
    const content = (
      <span>
        Are you sure you want to delete this {this.subPages[this.props.subMenuRoute].itemName}?
        <br />
        {this.props.objectIdentifier}
        <br /> {domainName}
      </span>
    );

    return (
      <ConfirmationModal
        isOpen={this.state.isModalOpen}
        size="mini"
        header="Confirm delete"
        content={content}
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={() =>
          this.props.editActions.delete(
            this.subPages[this.props.subMenuRoute].PdApiField as Api.OptionsGrud
          )
        }
        onCancel={this.toggleModal}
      />
    );
  };

  /*
   * Toggles the modal based on previous state.
   */
  private toggleModal = (): void => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen
    }));
  };
}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView),
  editedObjectId: editedObjectIdSelector(state.editView),
  editedObject: state.editView.editedObject,
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute),
  domainName: domainSelector(state.editView),
  filterOptions: state.filterOptions
});
const mapDispatchToProps = (dispatch: Dispatch<ColumnActions | EditActions | PdApiActions>) => ({
  columnActions: bindActionCreators({ ...columnActions }, dispatch),
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch),
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Enumerations);
